module.exports = require("./ha-NG.js");